import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

const lastSentToAgentMessageState = atom({
  key: 'lastSentToAgentMessageState',
  default: '',
});

/**
 * useLastSentToAgentMessage
 * To save the last message sent to Genesys agent, so we can retrieve it
 * and send it to agent after re-authenticated.
 */
export const useLastSentToAgentMessage = () => {
  const lastSentToAgentMessage = useRecoilValue(lastSentToAgentMessageState);
  const setLastSentToAgentMessage = useSetRecoilState(
    lastSentToAgentMessageState,
  );

  return {
    lastSentToAgentMessage,
    setLastSentToAgentMessage,
  };
};
